var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: true,
        "hide-footer": !_vm.multiple,
        size: "lg",
        title:
          _vm.title ??
          (_vm.multiple
            ? "Select or Upload Shapes"
            : "Select or Upload a Shape"),
      },
      on: {
        closed: function ($event) {
          return _setup.emit("cancel")
        },
      },
      scopedSlots: _vm._u(
        [
          _vm.multiple
            ? {
                key: "modal-footer",
                fn: function () {
                  return [
                    _c("span", { staticClass: "selection-count mr-auto" }, [
                      _vm._v(
                        _vm._s(_setup.model.selected.length) + " selected"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(_setup.CButton, {
                      attrs: { variant: "secondary", text: "Cancel" },
                      on: {
                        click: function ($event) {
                          return _setup.emit("cancel")
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(_setup.CButton, {
                      attrs: {
                        text: "Confirm",
                        disabled:
                          !_setup.model.selected.length ||
                          _setup.model.uploading,
                      },
                      on: { click: _setup.onConfirm },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "div",
        { staticClass: "mask-selector" },
        [
          _c("span", { staticClass: "filter-label" }, [
            _vm._v("Filter Shapes"),
          ]),
          _vm._v(" "),
          _c(_setup.CButtonGroup, {
            attrs: {
              value: _setup.model.filters,
              items: _setup.sources,
              type: "checkbox",
              size: "sm",
              pill: "",
              separate: "",
              "no-icon": "",
            },
            on: { input: _setup.onFiltersChange },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mask-grid" },
            [
              _c(
                "button",
                {
                  staticClass: "mask-tile upload-tile",
                  attrs: { type: "button", disabled: _setup.model.uploading },
                  on: { click: _setup.onUploadClicked },
                },
                [
                  _setup.model.uploading
                    ? _c("font-awesome-icon", {
                        staticClass: "fa-spin",
                        attrs: { icon: ["fas", "spinner-third"] },
                      })
                    : [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["far", "arrow-up-from-bracket"] },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Upload")]),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_setup.masks, function (mask) {
                return _c(
                  "button",
                  {
                    key: mask.id,
                    staticClass: "mask-tile",
                    class: {
                      disabled: _setup.isDisabled(mask),
                      selected: _vm.multiple && _setup.selectionOrder(mask),
                    },
                    attrs: {
                      type: "button",
                      title: _setup.isDisabled(mask)
                        ? "SVG masks cannot be used with an initial image position"
                        : mask.name,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.onMaskSelected(mask)
                      },
                    },
                  },
                  [
                    _c(_setup.CPreview, {
                      attrs: {
                        src: mask.thumbnailPath,
                        alt: mask.name,
                        "hide-wrapper": "",
                        "max-height": "100%",
                      },
                    }),
                    _vm._v(" "),
                    _vm.multiple && _setup.selectionOrder(mask)
                      ? _c("span", { staticClass: "selection-badge" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_setup.selectionOrder(mask)) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _setup.isEmpty
            ? _c("p", { staticClass: "empty-message" }, [
                _vm._v(_vm._s(_setup.emptyMessage)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _setup.totalMaskCount > _setup.PAGE_SIZE
            ? _c(_setup.CPagination, {
                attrs: {
                  value: _setup.model.page,
                  "total-count": _setup.totalMaskCount,
                  "page-count": _setup.PAGE_SIZE,
                },
                on: { input: _setup.onPageChange },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CFileInput, {
            ref: "fileInputRef",
            staticClass: "d-none",
            attrs: {
              value: [],
              accept: _setup.accept,
              multiple: _vm.multiple,
              "display-preview": false,
            },
            on: { input: _setup.onFileUpload },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }